module.exports = __webpack_public_path__ + "media/images/front/icon_down_arrow-46185afcad096c220a7560bedca61a08.svg";